import { render, staticRenderFns } from "./CompanyStat.vue?vue&type=template&id=3adfb521&scoped=true&"
import script from "./CompanyStat.vue?vue&type=script&lang=js&"
export * from "./CompanyStat.vue?vue&type=script&lang=js&"
import style0 from "./CompanyStat.vue?vue&type=style&index=0&id=3adfb521&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_cache-lo_8cdfb8a30e6790701421bf10ca45d28a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adfb521",
  null
  
)

export default component.exports